import React, { useState, useEffect } from 'react';
import axios from 'axios';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import validate from 'validate.js';
import {
	Card,
	CardHeader,
	CardContent,
	CardActions,
	Divider,
	Grid,
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import SelectImageCard from './imagePickerCard';
import { BaseButton } from 'views/UIWidgets';
import { photoUpload } from 'utils/helpers';
import ProductInfoInputView from './infoInputView';
import { schema, useStyles } from './constants';
import ArrowBack from 'views/UIWidgets/ArrowBack';

const CreateProduct = props => {
	const { className, history, globalProducts } = props;

	const { enqueueSnackbar } = useSnackbar();

	const classes = useStyles();

	const isEditing = props.match.params.id !== undefined;

	const initialProduct = isEditing
		? { ...globalProducts[props.match.params.id] }
		: {
				name: '',
				type: '喵星人',
				kinds: [],
				status: '现货',
				originalPrice: 0,
				currentPrice: 0,
				numberOfStock: 0,
				isRecommended: true,
				description: '0',
				salesVolume: 0,
				/**
				 * images: [{public_id: "abc", name: "name", url: "url", blob: abc, fileInfo: {}}]
				 */
				images: [],
				thumbnail: {},
				subProducts: [],
		  };

	const [productValue, setProductValue] = useState(initialProduct);

	const [pageValue, setPageValue] = useState({
		startPosting: false,
		startUpdating: false,
		errors: {},
	});

	const [isLoading, setLoading] = useState('');

	useEffect(() => {
		if (props.match.params.id && !globalProducts[props.match.params.id])
			history.push('/products');
		if (pageValue.startPosting === true) createProductRequest();
		if (pageValue.startUpdating === true) updateProductRequest();
	});

	const handleChange = event => {
		setProductValue({
			...productValue,
			[event.target.name]:
				event.target.type === 'number'
					? parseFloat(event.target.value)
					: event.target.value,
		});
		setPageValue({
			...pageValue,
			errors: {
				...pageValue.errors,
				[event.target.name]: false,
			},
		});
	};

	const handleCheck = event => {
		setProductValue({
			...productValue,
			[event.target.name]: event.target.checked,
		});
	};

	const handleCreateSubProduct = selectedProduct => {
		const indexOfProduct = productValue.subProducts?.findIndex(subProduct => {
			if (selectedProduct._id) {
				return subProduct._id === selectedProduct._id;
			} else if (selectedProduct.uuid) {
				return subProduct.uuid === selectedProduct.uuid;
			} else {
				return subProduct.name === selectedProduct.name;
			}
		});

		if (indexOfProduct >= 0) {
			const subProducts = productValue.subProducts;
			subProducts[indexOfProduct] = selectedProduct;
			setProductValue({
				...productValue,
				subProducts: subProducts,
			});
		} else {
			setProductValue({
				...productValue,
				subProducts: productValue.subProducts
					? productValue.subProducts.concat(selectedProduct)
					: [selectedProduct],
			});
		}
	};

	const handleDeleteSubProduct = selectedProduct => {
		const indexOfProduct = productValue.subProducts?.findIndex(
			subProduct => subProduct.name === selectedProduct.name
		);

		if (indexOfProduct >= 0) {
			const subProducts = productValue.subProducts;
			subProducts.splice(indexOfProduct, 1);
			setProductValue({
				...productValue,
				subProducts: subProducts,
			});
		}
	};

	const uploadSubProductImage = async () => {
		var subProducts = productValue.subProducts;
		for (var subProduct of subProducts) {
			if (subProduct.image && subProduct.image.file) {
				// upload subproduct image
				try {
					const res = await photoUpload([subProduct.image.file]);
					subProducts[subProducts.indexOf(subProduct)] = {
						...subProduct,
						image: {
							public_id: res.data.public_id,
							name: res.data.original_filename,
							url: res.data.secure_url,
						},
					};
				} catch (error) {
					console.log(error);
				}
			}
		}

		return subProducts;
	};

	const uploadthumbnailsImage = async () => {
		// if it is local file, upload image then store url to state
		// Do nothing if it just a url, means no change locally
		var thumbnailToUpdate = productValue.thumbnail;
		if (thumbnailToUpdate && thumbnailToUpdate.file) {
			try {
				const res = await photoUpload([thumbnailToUpdate.file]);
				thumbnailToUpdate = {
					public_id: res.data.public_id,
					name: res.data.original_filename,
					url: res.data.secure_url,
				};
			} catch (error) {
				console.log(error);
			}
		}
		return thumbnailToUpdate;
	};

	const uploadImages = async () => {
		const imagesToUpdate = productValue.images;
		if (imagesToUpdate && imagesToUpdate.length > 0) {
			for (var image of imagesToUpdate) {
				if (image.file) {
					try {
						const res = await photoUpload([image.file]);
						imagesToUpdate[imagesToUpdate.indexOf(image)] = {
							public_id: res.data.public_id,
							name: res.data.original_filename,
							url: res.data.secure_url,
						};
					} catch (error) {
						console.log(error);
					}
				}
			}
		}
		return imagesToUpdate;
	};

	const handleUploadImage = async () => {
		const subProductsWithURL = await uploadSubProductImage();

		const thumbnailToUpdate = await uploadthumbnailsImage();

		const imagesToUpdate = await uploadImages();

		setProductValue({
			...productValue,
			images: imagesToUpdate,
			thumbnail: thumbnailToUpdate,
			subProducts: subProductsWithURL,
		});

		setPageValue({
			...pageValue,
			[isEditing ? 'startUpdating' : 'startPosting']: true,
		});
	};

	const handleSelectImage = (images, name) => {
		if (name === 'productThumbnails') {
			setProductValue({
				...productValue,
				thumbnail: images[0],
			});
		} else {
			setProductValue({
				...productValue,
				images: productValue.images.concat(images),
			});
		}
	};

	const handleSubmit = async () => {
		const errors = validate(productValue, schema);

		if (errors) {
			setPageValue({
				...pageValue,
				errors: errors || {},
			});
			return;
		}

		setLoading(isEditing ? 'editing' : 'creating');

		handleUploadImage();
	};

	const handleDelete = async () => {
		setLoading('deleting');
		try {
			await axios.delete(`/api/products/${props.match.params.id}`);
			enqueueSnackbar('商品删除成功', { variant: 'success' });

			return history.goBack();
		} catch (error) {
			console.log(error);
		}
	};

	const createProductRequest = async () => {
		try {
			await axios.post('/api/products', productValue);
			enqueueSnackbar('商品创建成功', { variant: 'success' });

			// Push to product view page
			return history.goBack();
		} catch (error) {
			console.log(error);
		}

		setPageValue({
			...pageValue,
			startPosting: false,
		});
	};

	const updateProductRequest = async () => {
		try {
			await axios.put(`/api/products/${props.match.params.id}`, productValue);

			enqueueSnackbar('商品更新成功', { variant: 'success' });

			return history.goBack();
		} catch (error) {
			enqueueSnackbar(`商品更新失败, error ${error.message}`, {
				variant: 'error',
			});
		}
	};

	const handleMultipleSelect = e => {
		setProductValue({
			...productValue,
			[e.target.name]: e.target.value,
		});
	};

	const inputsContent = () => {
		return (
			<ProductInfoInputView
				product={productValue}
				errors={pageValue.errors}
				handleChange={handleChange}
				handleCheck={handleCheck}
				handleMultipleSelect={handleMultipleSelect}
				handleCreateSubProduct={handleCreateSubProduct}
				handleDeleteSubProduct={handleDeleteSubProduct}
				handleUpdateProduct={newValue => {
					setProductValue({
						...productValue,
						...newValue,
					});
				}}
			/>
		);
	};

	const imagePickContent = () => {
		const { thumbnail, images } = productValue;

		const imageArray = images ?? [];

		const thumbnailArray =
			thumbnail &&
			Object.keys(thumbnail).length === 0 &&
			thumbnail.constructor === Object
				? []
				: [thumbnail].filter(item => item?.url !== undefined); // remove undefined

		return (
			<Grid container spacing={3}>
				<Grid item xs={6}>
					<SelectImageCard
						title='商品缩略图'
						subTitle='点击按钮上传商品的一张缩略图'
						images={thumbnailArray}
						handleSelect={handleSelectImage}
						multiple={false}
						name='productThumbnails'
						onDelete={() => {
							setProductValue({
								...productValue,
								thumbnail: {},
							});
						}}
						limit={1}
					/>
				</Grid>
				<Grid item xs={6}>
					<SelectImageCard
						title='商品图片'
						subTitle='点击按钮上传商品细节图片'
						images={imageArray}
						handleSelect={handleSelectImage}
						multiple={true}
						name='productImages'
						handleClear={() => {
							setProductValue({
								...productValue,
								images: [],
							});
						}}
						limit={6}
						onDelete={index => {
							setProductValue({
								...productValue,
								images: productValue.images.filter((_, i) => i !== index),
							});
						}}
						onReorder={(prevIndex, currentIndex) => {
							const result = productValue.images;
							const [removed] = result.splice(prevIndex, 1);
							result.splice(currentIndex, 0, removed);

							setProductValue({
								...productValue,
								images: result,
							});
						}}
					/>
				</Grid>
			</Grid>
		);
	};

	const rederButton = () => {
		return isEditing ? (
			<>
				<BaseButton
					isLoading={isLoading === 'editing'}
					title='修改商品'
					onClick={handleSubmit}
				/>
				<BaseButton
					isLoading={isLoading === 'deleting'}
					title='删除商品'
					color='danger'
					onClick={handleDelete}
				/>
			</>
		) : (
			<BaseButton
				isLoading={isLoading === 'creating'}
				title='创建商品'
				onClick={handleSubmit}
			/>
		);
	};

	return (
		<>
			<ArrowBack history={history} />
			<Card className={clsx(classes.root, className)}>
				<form autoComplete='off' noValidate>
					<CardHeader
						subheader={isEditing ? '在下面编辑现有商品' : '在下面创建新的商品'}
						title={isEditing ? '编辑商品' : '创建商品'}
					/>
					<Divider />
					<CardContent>
						<Grid container spacing={3}>
							<Grid item md={5} xs={12}>
								{inputsContent()}
							</Grid>
							<Grid item md={7} xs={12}>
								{imagePickContent()}
							</Grid>
						</Grid>
					</CardContent>
					<Divider />
					<CardActions className={classes.buttonContainer}>
						{rederButton()}
					</CardActions>
				</form>
			</Card>
		</>
	);
};

const mapStateToProps = state => {
	return { globalProducts: state.products };
};

export default connect(mapStateToProps)(withRouter(CreateProduct));
